import { Component, input, Input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

/**
 * Displays an alert notification with optional title and message
 * @example
 * <notification-alert
 *   type="warning"
 *   title="Certificate Expired"
 *   message="Your tax exemption certificate has expired."
 * ></notification-alert>
 */
export type AlertType = 'info' | 'success' | 'warning' | 'danger';

@Component({
  selector: 'notification-alert',
  imports: [MatIconModule],
  templateUrl: './notification-alert.component.html',
  styleUrl: './notification-alert.component.scss',
  standalone: true,
  host: {
    '[attr.id]': 'null',
  },
})
export class NotificationAlertComponent {
  @Input() message: string;
  @Input() type: AlertType = 'info';
  @Input() title: string;
  @Input() cssClass: string = '';
  @Input() id: string;
  @Input() boldTitle: boolean = true;
  showCloseButton = input<boolean>(false);
  dismissed = output<void>();

  protected icon = {
    info: 'info',
    success: 'circle-check',
    warning: 'alert-circle',
    danger: 'error-circle',
  } as const;
}
